import { render, staticRenderFns } from "./aboutDetail.vue?vue&type=template&id=2af409d3&scoped=true&"
import script from "./aboutDetail.vue?vue&type=script&lang=js&"
export * from "./aboutDetail.vue?vue&type=script&lang=js&"
import style0 from "./aboutDetail.vue?vue&type=style&index=0&id=2af409d3&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2af409d3",
  null
  
)

export default component.exports